import { appState } from "./state";
import { notifyStateChange } from "./stateBus";
import { apiFetch } from "./api";
import { requestLock } from "./lockBus";
import type { PresenceChangedData } from "./chatSocket";

// Online = has at least one open chat WebSocket, server-side (server.js's
// isUserOnline/broadcastPresence, next to the chatSockets map that already
// tracks this for message delivery - presence is free real-time data
// riding the same connection, not a new tracking mechanism).

export async function loadPresenceData(): Promise<void> {
  try {
    const res = await apiFetch("/api/presence");
    if (res.status === 401) {
      requestLock("unauthorized");
      return;
    }
    if (!res.ok) return;
    const data = await res.json();
    appState.presenceUsers = Array.isArray(data.users) ? data.users : [];
    notifyStateChange();
  } catch {
    // Best effort - the next protected-features poll tick retries.
  }
}

export function applyPresenceChanged(data: PresenceChangedData): void {
  appState.presenceUsers = appState.presenceUsers.map((u) =>
    u.id === data.userId ? { ...u, online: data.online, fullName: data.name || u.fullName } : u,
  );
  notifyStateChange();
}
